import { useState } from 'react';
import useCapture from '../../../hooks/useCapture';

// A recorded story can be transcribed by the Studio (private upload, quoted credits).
// The transcript only fills the text field: the creator corrects it, and it is
// marked reviewed when the story is used.
export default function useStoryForm(s) {
  const [transcription, setTranscription] = useState(null);
  const [text, setText] = useState('');
  const [remember, setRemember] = useState(false);
  const [transcribing, setTranscribing] = useState(false);
  const capture = useCapture();
  const canTranscribe = Boolean(s.current && s.features.audio);
  const transcribe = async () => {
    if (!capture.blob || transcribing) return;
    setTranscribing(true);
    const result = await s.transcribe(capture.blob, capture.mimeType);
    if (result) { setTranscription(result); setText(result.text || ''); }
    setTranscribing(false);
  };
  const reuse = async memory => { if (await s.respond('reuse', null, memory.id)) s.setModal(null); };
  const skip = async () => {
    if (s.run?.status === 'waiting_user' && !(await s.respond('skip'))) return;
    s.setModal(null);
  };
  const submit = async onComplete => { if (await s.storySubmit(text, remember, transcription)) onComplete?.(); };
  return { transcription, text, setText, remember, setRemember, transcribing, capture, canTranscribe, transcribe, reuse, skip, submit };
}
